/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Swimming_Coaching_TermsInputs */

const en_service_type_swimming_coaching_terms = /** @type {(inputs: Service_Type_Swimming_Coaching_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`swimming, swim lessons, pool, swim coach, front crawl`)
};

const pl_service_type_swimming_coaching_terms = /** @type {(inputs: Service_Type_Swimming_Coaching_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pływanie, nauka pływania, basen, trener pływania, kraul`)
};

/**
* | output |
* | --- |
* | "swimming, swim lessons, pool, swim coach, front crawl" |
*
* @param {Service_Type_Swimming_Coaching_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_swimming_coaching_terms = /** @type {((inputs?: Service_Type_Swimming_Coaching_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Swimming_Coaching_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_swimming_coaching_terms(inputs)
	return en_service_type_swimming_coaching_terms(inputs)
});